import type { EmbeddedMode } from "@intelligems/ig-types";
import { RootState } from "@src/store";
import { componentSlice } from "@src/store/slices/experienceBuilder/component/slice";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

export function getEmbeddedMode(state: RootState): EmbeddedMode {
  if (componentSlice.selectors.isActive(state)) return "insert";
  return experienceBuilderSlice.selectors.getMode(state);
}
